import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { Exchange } from '@/assets/icons'
import { useTheme } from '@/hooks/useTheme'
import { useSavingsStore } from '@/store/useSavingsStore'
import { currencyUtils } from '@/utils'

const { formatDynamicCurrency } = currencyUtils

export const SetGoalConversionRelative: React.FC = () => {
  const theme = useTheme()
  const isFiatMode = useSavingsStore((s) => s.goal.isFiatMode)
  const setGoal = useSavingsStore((s) => s.setGoal)
  const fiatAmount = useSavingsStore((s) => s.goal.fiatAmount)
  const cryptoAmount = useSavingsStore((s) => s.goal.cryptoAmount)

  // Показываем противоположную валюту от текущего режима
  const adaptedAmount = isFiatMode ? cryptoAmount : fiatAmount

  // Форматируем сумму для отображения
  const formattedRelativeAmount = formatDynamicCurrency({
    amount: adaptedAmount.amount,
    currencyCode: adaptedAmount.code,
    showDecimals: true,
  })

  const handlePress = () => {
    setGoal({ isFiatMode: !isFiatMode })
  }

  // Не показываем, если сумма равна 0 или пустая
  if (!adaptedAmount.amount || adaptedAmount.amount === '0') {
    return null
  }

  return (
    <BaseView row align="center" gap={4}>
      <BaseText
        fontSize={18}
        fontFamily="bold"
        color="label.default"
        style={{
          textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        {formattedRelativeAmount || '0'}
      </BaseText>
      <BaseView
        center
        className="cursor-pointer hover:opacity-80 transition-opacity duration-200 active:scale-95"
        style={{
          padding: 8,
          borderRadius: 20,
        }}
        onClick={handlePress}
      >
        <Exchange
          size={18}
          color={theme.colors.label.default}
          style={{
            filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))',
          }}
        />
      </BaseView>
    </BaseView>
  )
}
